export class TypesSetupModel {
    typeid: number;
    typecode: string;
    description: string;
    category: string;
    categoryid: number;
    typedescription: string;
    constructor(
        typeid: number,
        typecode: string,
        description: string,
        category: string,
        categoryid: number,
        typedescription: string
    ) {
        this.typeid = typeid;
        this.typecode = typecode;
        this.description = description;
        this.category = category;
        this.categoryid = categoryid;
        this.typedescription = typedescription;
    }
}
